<script>
import { humanizeDuration } from './use-humanize-duration'

export default {
  name: 'HumanizedDuration',
  props: {
    start: {
      type: [String, Object],
      validator(value) {
        if (typeof value === 'object') {
          return dayjs.isDayjs(value)
        }
        return true
      },
    },
    end: {
      type: [String, Object],
      validator(value) {
        if (typeof value === 'object') {
          return dayjs.isDayjs(value)
        }
        return true
      },
    },
    minutes: { type: Number, default: null },
    useSeconds: { type: Boolean, default: false },
    seconds: { type: Number, default: null },
    showEmpty: {
      type: Boolean,
      default: true,
    },
    oneLetter: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      humanizeDuration: humanizeDuration(props),
    }
  },
  computed: {
    humanizedDuration() {
      return humanizeDuration({
        seconds: this.seconds,
        minutes: this.minutes,
        useSeconds: this.useSeconds,
        oneLetter: this.oneLetter,
        start: this.start,
        end: this.end,
      })
    },
  },
}
</script>

<template lang="pug">
span.text-black-15(
  v-if="!start && !end && (useSeconds ? !seconds && seconds != 0 : !minutes && minutes != 0)"
)
  span(v-if="showEmpty") empty
span(v-else) {{ humanizedDuration }}
</template>
